<template>
  <div>
    <a-button
      v-if="!props.shape.attrs.customFontFile"
      class="text-red-500 !bg-[#313131] !w-full !h-[52px]"
      @click="handleUploadFont"
    >
      请上传字体文件（.ttf格式）
    </a-button>
    <div
      v-else
      class="mt-2.5 flex items-center justify-between text-[#c2c2c2] !bg-[#313131] !w-full !h-[52px] rounded-[8px] px-5"
    >
      <span>字体：{{ props.shape.attrs.customFontName }}</span>
      <a-button
        class="!bg-[#313131] border-0"
        size="small"
        type="link"
        @click="handleUploadFont"
      >
        修改文件
      </a-button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useTextFont } from '@/hooks';
import { ElectronApi } from '@/services/electron.api';
import { Shape } from '@/services/shape';
import { WatchfaceService } from '@/services/watchface';
import { onMounted, PropType, watch } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

const { pickThenUploadFont, loadFontFile } = useTextFont();

const handleUploadFont = async () => {
  try {
    const { fontFilename, fontBaseName } = (await pickThenUploadFont()) ?? {};
    if (fontFilename && fontBaseName) {
      props.shape.setAttrs({
        customFontFile: fontFilename,
        customFontName: fontBaseName
      });
      await loadFont();
    }
  } catch (error) {
    console.error('字体上传失败:', error);
    props.shape.setAttrs({
      customFontFile: '',
      customFontName: ''
    });
  }
};

const loadFont = async () => {
  const path = ElectronApi.path;
  if (!path) return;

  const { customFontFile } = props.shape.attrs;
  if (!customFontFile) return;
  const fontId = customFontFile.split('.')[0];

  const fontFile = path.join(
    new WatchfaceService().ResourcePath,
    customFontFile
  );

  await loadFontFile({
    local: {
      fontId,
      fontFile
    }
  });
};
watch(
  () => props.shape.attrs.fontId,
  () => {
    if (props.shape.attrs.fontId !== 'custom') return;
    loadFont();
  }
);

onMounted(() => {
  loadFont();
});
</script>

<style lang="less" scoped></style>
